/**
 * @typedef {import('../../../../App/shared/Query/Parameters').default} QueryParameters
 * @typedef {import('../../../../shared/AgentContactService/ContactsData').default} ContactsData
 * @typedef {import('./Response').default} Response
 */

import { agentContactService } from '../../../../service-container';
import { translate } from '../../../../App/Internationalization';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {boolean} [isGated]
 * @param {QueryParameters} [query]
 * @returns {Response}
 */
export default function useGetAgentContacts(isGated, query) {
	const [contacts, setContacts] = useState(/** @type {ContactsData|null} */ (null)); //	prettier-ignore
	const [errorMessage, setErrorMessage] = useState('');
	const [isGettingData, setIsGettingData] = useState(!isGated);

	useEffect(() => {
		if (isGated) {
			setIsGettingData(false);
			return;
		}

		fetchData();
	}, [isGated, query]);

	/** @returns {Promise<void>} */
	async function fetchData() {
		setIsGettingData(true);

		try {
			const response = await agentContactService.getContacts(query);

			setContacts(response);
		} catch (error) {
			captureError(error);
			setErrorMessage(translate('agent.pages.contacts.errors.fetch'));
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: contacts,
			errorMessage,
			isGettingData,
		}),
		[contacts, errorMessage, isGettingData]
	);
}
